import { useEffect, useState } from "react"
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import { ExportIcon, CloseIcon } from "../Icons";
import { addTemplateToDb, loadTemplatesData, addCoverImageInCategory, createNewCategory, removeCategory } from "../../utils/giftcardControllers";
import { useTranslation } from "react-i18next";
import "../../localisation/index"
import "../styles/model.css"
// import TemplateData from "../../sampleData/templates.json"

export default function ModelOpener({setModel, templateImages, setTemplateImages}) {
    const [modelData, setModelData] = useState({
        activeItem: null,
        loading: true,
        errorMsg: '',
        importLoading: false,
        exportLoading: false,
        modelTemplates: [],
        temporarySelectedImages: []
    })
    const [isAddingCategory, setIsAddingCategory] = useState(false);
    const [addCategoryLoader, setAddCategoryLoader] = useState(false)
    const [removeCategoryLoader, setRemoveCategorLoader] = useState(false)
    const [newCategory, setNewCategory] = useState("");
    const {t} = useTranslation()

    useEffect(()=>{
        const getTemplatesData=async()=>{
            try {
                const response = await loadTemplatesData()
                
                const {success, data, message} = response
                if(success){
                    console.log("templates", data)
                    setModelData((prev)=>({...prev, activeItem: data[0], modelTemplates: data, temporarySelectedImages: templateImages}))
                }else{
                    setModelData((prev)=>({...prev, errorMsg: message}))
                }

                // adding sample data from json for development
                // setModelData((prev)=>({...prev, activeItem: TemplateData.templates[0], modelTemplates: TemplateData.templates, temporarySelectedImages: templateImages}))
            } catch(e) {
                console.log('Error', e.message)
                setModelData((prev)=>({...prev, errorMsg: e.message}))
            } finally {
                setModelData((prev)=>({...prev, loading: false}))
            }
        }
        getTemplatesData()
    },[templateImages])

    const saveSelectedImages=()=>{
        if(modelData.temporarySelectedImages.length===0){
            alert(t("createGiftcard.minImageError"))
            return
        }

        setModel(false)
        setTemplateImages(modelData.temporarySelectedImages)
        alert(t("createGiftcard.importSuccess"))
    }

    const handleImageSelection = (category, coverImage = null, templateImage = null, isCoverImage = false, isChecked = false) => {
        setModelData((prev) => {
            const existingCategory = prev.temporarySelectedImages.find(item => item.category === category);
            if(existingCategory?.cover_image && isCoverImage){
                return {
                    ...prev,
                    temporarySelectedImages: prev.temporarySelectedImages.filter(item => item.category !== category)
                }
            }
            
            let updatedTemplateImages = existingCategory?.template_images || [];
    
            if (templateImage) {
                if (isChecked) {
                    updatedTemplateImages.push(templateImage);
                } else {
                    updatedTemplateImages = updatedTemplateImages.filter(img => img !== templateImage);
                }
            }
            const updatedSelection = prev.temporarySelectedImages.filter(item => item.category !== category);
            return {
                ...prev,
                temporarySelectedImages: [
                    ...updatedSelection,
                    {
                        category,
                        cover_image: coverImage || existingCategory?.cover_image || "",
                        template_images: updatedTemplateImages
                    }
                ]
            };
        });
    };

    const handleAddImage =(type="") => {
        let fileInput=''
        switch(type){
            case "COVER":
                fileInput = document.getElementById("cover-image-picker");
                break;
            case "TEMPLATE":
                fileInput = document.getElementById("template-file-picker");
                break;
            default:
                return null
        }
        const file = fileInput.files[0];
        
        if (!file) {
          alert(t("createGiftcard.selectImage"));
          return;
        }
        const reader = new FileReader();

        reader.onloadend =() => {
            const img = new Image();
            img.onload =async () => {
                if ((img.width === 600 && img.height === 250) || (img.width === 180 && img.height === 180) ) {
                    const dataURLWithoutPrefix = reader.result.split(",")[1];
                    // const dataURLWithoutPrefix = reader.result
                    try{
                        setModelData((prev) => ({ ...prev, importLoading: true }));
                        if(type==="COVER"){
                            const {success, data, message} = await addCoverImageInCategory(dataURLWithoutPrefix, modelData.activeItem.category)
                            if(success){
                                const responseImage = data.image_url
                                if(responseImage){
                                    setModelData(prevState => {
                                        // Create a new copy of modelTemplates array
                                        const updatedTemplates = prevState.modelTemplates.map(template => {
                                            if (template.category === prevState.activeItem.category) {
                                                return {
                                                    ...template,
                                                    cover_images: [...template.cover_images, responseImage]
                                                };
                                            }
                                            return template;
                                        });
                                
                                        return {
                                            ...prevState,
                                            modelTemplates: updatedTemplates,
                                            activeItem: {
                                                ...prevState.activeItem,
                                                cover_images: [...prevState.activeItem.cover_images, responseImage]
                                            }
                                        };
                                    });
                                    console.log("Cover image added successfully!");
                                }
                            }else{
                                alert(t("errors.serverError"));
                                console.log("message", message)
                            }
                        }else if(type==="TEMPLATE"){
                            const {success, data, message} = await addTemplateToDb(dataURLWithoutPrefix, modelData.activeItem?.category)
                            if(success){
                                const responseImage = data[0].image_url
                                if(responseImage){
                                    setModelData(prevState => {
                                        // Create a new copy of modelTemplates array
                                        const updatedTemplates = prevState.modelTemplates.map(template => {
                                            if (template.category === prevState.activeItem.category) {
                                                return {
                                                    ...template,
                                                    template_images: [...template.template_images, responseImage] // Append new image
                                                };
                                            }
                                            return template;
                                        });
                                
                                        return {
                                            ...prevState,
                                            modelTemplates: updatedTemplates,
                                            activeItem: {
                                                ...prevState.activeItem,
                                                template_images: [...prevState.activeItem.template_images, responseImage] // Update activeItem as well
                                            }
                                        };
                                    });
                                    console.log("Image added successfully!");
                                }
                            }else{
                                console.log("message", message)
                            }
                        }
                    } catch(e){
                        console.log("Add Error", e.message)
                        alert(e.message)
                    } finally {
                        setModelData((prev) => ({ ...prev, importLoading: false }));
                        fileInput.value = "";
                    }
                } else {
                    if(type==="COVER"){
                        alert(`Enter a valid image dimension with 180x180. Your image dimensions are ${img.width} ${img.height}`)
                    }else{
                        alert(t("createGiftcard.invalidDimensions")+`(${img.width}x${img.height})`);
                    }
                    fileInput.value = ""
                }
            };
    
            img.src = reader.result;
        };
        reader.readAsDataURL(file);
    };

    const handleAddCategory = async() => {
        if (!newCategory.trim()) return;
        setAddCategoryLoader(true)
    
        const newCategoryObj = {
            category: newCategory,
            cover_images: [],
            template_images: [],
            isRemovable: true
        };
    
        setModelData((prev) => ({
            ...prev,
            modelTemplates: [...prev.modelTemplates, newCategoryObj],
            activeItem: newCategoryObj
        }));
    
        const response = await createNewCategory(newCategory)

        setIsAddingCategory(false);
        setNewCategory("");
        setAddCategoryLoader(false)
    };
    const handleRemoveCategory=async(e, item)=>{
        e.stopPropagation()
        if(!item) return
        setRemoveCategorLoader(true)
        const response = await removeCategory(item)
        if(response.success){
            setModelData(prev=>{
                if(prev?.activeItem?.category === item.category){
                    return {
                        ...prev,
                        activeItem: prev.modelTemplates[0],
                        modelTemplates: prev.modelTemplates.filter(template=>template.category!== item.category)
                    }
                } return {
                    ...prev,
                    modelTemplates: prev.modelTemplates.filter(template=>template.category!== item.category)
                }
            })
        }
    }

    return (
        <div className="model-opener">
            <div className="model-container">
                <div className="model-header">
                    {
                        modelData.importLoading ? (
                            <button>
                                <div className="loading-container loader-button">
                                    <AiOutlineLoading3Quarters className="spinner" size={12} color="blue" />
                                </div>
                            </button>
                        ) : (
                            <button onClick={saveSelectedImages} className="import-button">{t("createGiftcard.import")}</button>
                        )
                    }
                    <div className="model-header-close">
                        <button onClick={()=>{setModel(false)}}>
                            <CloseIcon />
                        </button>
                    </div>
                </div>
                <div className="model-body">
                    {
                        modelData.loading ? (
                            <div className="loading-container">
                                <AiOutlineLoading3Quarters className="spinner" size={25} color="blue" />
                            </div>
                        ) : modelData.errorMsg ? (<p className="text-left">{modelData.errorMsg}</p>) : (
                            <div className="template-category-images-container">
                                <div className="templates-category">
                                    <ul className="templates-category-list">
                                        {
                                            modelData.modelTemplates.length > 0 && (
                                                modelData.modelTemplates.map((item, index)=>(
                                                    <li onClick={()=>{setModelData((prev)=>({...prev, activeItem: item}))}} key={index} className={`template-category-tab ${item.category === modelData.activeItem.category && 'active-tab' }`}>
                                                        {item.category}
                                                        {
                                                            item.isRemovable && <span disabled={removeCategoryLoader} onClick={(e)=>handleRemoveCategory(e, item)} className="category-tab__remove"><CloseIcon width={16} height={16} /></span>
                                                        }
                                                    </li>
                                                ))
                                            )
                                        }
                                        {isAddingCategory ? (
                                            <li className="add-category-input">
                                                <input
                                                    type="text"
                                                    value={newCategory}
                                                    onChange={(e) => setNewCategory(e.target.value)}
                                                    placeholder={t("emailTemplates.enterCategoryName")}
                                                    autoFocus
                                                />
                                                <button disabled={addCategoryLoader} onClick={handleAddCategory}>{t("emailTemplates.submit")}</button>
                                                <button onClick={() => setIsAddingCategory(false)}>{t("emailTemplates.cancel")}</button>
                                            </li>
                                        ) : (
                                            <li className="add-category-button" onClick={() => setIsAddingCategory(true)}>{t("emailTemplates.addNewCategory")}</li>
                                        )}
                                    </ul>
                                </div>
                                <div>
                                    <h2 className="category-cover-heading">{t("emailTemplates.selectCoverImage")}</h2>
                                    <div className="template-category-images">
                                        {
                                            modelData.activeItem?.cover_images?.map((url, index)=>{
                                                const isChecked = modelData.temporarySelectedImages.find(
                                                    item => item.category === modelData.activeItem.category
                                                )?.cover_image === url;
                                                return (
                                                    <label htmlFor={`model-cover-image-${index}`} key={index} className="category-cover-image">
                                                        {isChecked ? <span className="selected-cover-image">✅</span> : <span className="cover-image-radio"> </span>}
                                                        <input
                                                            type="radio"
                                                            id={`model-cover-image-${index}`}
                                                            name={modelData.activeItem.category}
                                                            data-url={url}
                                                            value={url}
                                                            checked={isChecked}
                                                            onClick={() => {
                                                                if (isChecked) {
                                                                    handleImageSelection(modelData.activeItem.category, url, false, true);
                                                                }
                                                            }}
                                                            onChange={() => handleImageSelection(modelData.activeItem.category, url, false, true)}
                                                        />
                                                        <img src={url} alt="" />
                                                    </label>
                                                )}
                                            )
                                        }
                                        <div className="image-picker-container">
                                            <label for="cover-image-picker" className="image-picker-label">
                                                <div className="image-picker-preview" id="cover-image-review">
                                                    <span>{t("emailTemplates.addCoverImage")}</span>
                                                </div>
                                                <input 
                                                    type="file" 
                                                    id="cover-image-picker" 
                                                    onChange={()=>handleAddImage("COVER")} 
                                                    accept="image/*" 
                                                    hidden 
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    {
                                        modelData.temporarySelectedImages.find(
                                            item => item.category === modelData.activeItem.category
                                        )?.cover_image && (
                                            <>
                                                <h2 className="category-cover-heading">{t("emailTemplates.selectCategoryImages")}</h2>
                                                <div className="template-category-images">
                                                    {
                                                        modelData.activeItem?.template_images?.length > 0 ? (
                                                            modelData.activeItem.template_images.map((url, index)=>{

                                                                const isChecked = modelData.temporarySelectedImages.find(
                                                                    item => item.category === modelData.activeItem.category
                                                                )?.template_images.includes(url);

                                                                return (
                                                                    <label htmlFor={`model-template-image-${index}`} key={index} className="image-checkbox-container">
                                                                        <input 
                                                                            data-url={url} 
                                                                            data-category={url}
                                                                            type="checkbox" 
                                                                            value={url}
                                                                            className="image-checkbox"
                                                                            id={`model-template-image-${index}`}
                                                                            checked={isChecked}
                                                                            onChange={(e) => handleImageSelection(
                                                                                modelData.activeItem.category, 
                                                                                null, 
                                                                                url, 
                                                                                false,
                                                                                e.target.checked
                                                                            )}
                                                                        />  
                                                                        <img src={url} alt="" />
                                                                    </label>
                                                                )
                                                            })
                                                        ) : (
                                                            <p className="empty-templates">{t("createGiftcard.noTemplates")}</p>
                                                        )
                                                    }
                                                </div>
                                                <div className="add-image-container">
                                                    <label htmlFor="template-file-picker" className={modelData.importLoading ? "disabled-label" : ""}>
                                                        <ExportIcon /> {t("emailTemplates.importCategoryImage")}
                                                    </label>
                                                    <input 
                                                        type="file" 
                                                        id="template-file-picker" 
                                                        accept="image/*" 
                                                        onChange={()=>{handleAddImage("TEMPLATE")}} 
                                                        disabled={modelData.importLoading} 
                                                    />
                                                </div>
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    )
}